/**
 * RegulatoryFlagsFilter Component
 *
 * Multi-select filter for regulatory flags (Vulnerability, Complaint).
 * Default is AND logic (must have ALL flags), user can toggle to OR (match ANY).
 * This is an inclusion filter - only shows records with the selected flags.
 */

import { AlertTriangle } from 'lucide-react';
import { FilterDropdown } from './FilterDropdown';
import type { RegulatoryFlagsFilterProps, RegulatoryFlag } from '../types/filter.types';
import { REGULATORY_FLAG_OPTIONS, DEFAULT_FILTER_LOGIC } from '../constants/filter.constants';
import { useFilterWithLogic } from '../hooks/useFilterWithLogic';

export function RegulatoryFlagsFilter({
  value,
  onChange,
  disabled = false,
  className,
}: RegulatoryFlagsFilterProps) {
  const { currentLogic, handleValuesChange, handleLogicChange, helperText } =
    useFilterWithLogic<RegulatoryFlag>({
      value,
      onChange,
      defaultLogic: DEFAULT_FILTER_LOGIC.regulatoryFlags,
      noun: 'flags',
    });

  return (
    <FilterDropdown
      value={value?.values}
      onChange={handleValuesChange}
      options={REGULATORY_FLAG_OPTIONS}
      icon={<AlertTriangle className="h-4 w-4" />}
      emptyLabel="All Flags"
      pluralNoun="flags"
      helperText={helperText}
      showDescriptions
      disabled={disabled}
      className={className}
      logicMode={currentLogic}
      onLogicModeChange={handleLogicChange}
    />
  );
}
